const Page = ({style, children}) => <div className="w-100 h-100 p-absolute" style={{top:0, left:0, right:0, bottom: 0, overflow:'hidden', ...style}}>{children}</div>;

export default Page;